<template>
  <div class="form-panel">
    <div class="form-panel__header">
      <h2 class="titulo-h2">Iniciar Sesión</h2>
    </div>
    <div class="form-panel__body">
      <div class="form-fields form-fields-invertido" v-if="imagen.length > 0">
        <div class="form-fields__secundario">
          <img class="img-home-banner" :src="imagen" />
        </div>
      </div>
      <div class="form-fields form-fields-invertido">
        <div class="form-fields__secundario">
          <h2 class="titulo-h3">Ingresar con Facebook</h2>
          <div class="form-fields__secundario-botones">
            <router-link
              class="m-btn-icon m-btn-icon-facebook waves-effect waves-light"
              :to="{ name: 'facebook-login-url' }"
            />
            <!-- <a class="m-btn-icon m-btn-icon-google waves-effect waves-light" tabindex="0"/> -->
          </div>
        </div>
        <div class="form-fields__principal">
          <h2 class="titulo-h3-light">O ingresa con tu correo electrónico</h2>
          <form class="form" action="">
            <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.email.$error,
                'form__group-valid': !$v.form.email.$invalid,
              }"
            >
              <i class="icon-field icon-field-email"></i>
              <label for="email">Email</label>
              <input
                id="email"
                type="email"
                @blur="$v.form.email.$touch()"
                v-model="form.email"
              />
              <div class="form__group-validation" v-if="$v.form.email.$dirty">
                <p v-if="!$v.form.email.required">
                  Debes especificar un correo.
                </p>
                <p v-if="!$v.form.email.email">
                  El formato de correo no es válido.
                </p>
              </div>
            </div>

            <!-- tipo documento -->
            <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.IdTipoDocumento.$error,
                'form__group-valid': !$v.form.IdTipoDocumento.$invalid,
              }"
            >
              <i class="icon-field icon-field-arrow"></i>
              <label for="idTiposDocumento">Tipo de Documento</label>
              <v-select
                class="selectField"
                :items="tiposDocumento"
                v-model="form.IdTipoDocumento"
                item-text="descripcion"
                item-value="idTiposDocumento"
                label="Seleccione su tipo de documento"
                solo
              ></v-select>
              <div
                class="form__group-validation"
                v-if="$v.form.IdTipoDocumento.$dirty"
              >
                <p v-if="!$v.form.IdTipoDocumento.minValue">
                  Debes especificar un tipo de documento.
                </p>
              </div>
            </div>
            <!-- documento -->
            <div
              class="form__group"
              :class="{
                'form__group-invalid': $v.form.documento.$error,
                'form__group-valid': !$v.form.documento.$invalid,
              }"
            >
              <i class="icon-field icon-field-arrow"></i>
              <label for="documento">Documento</label>
              <input
                id="documento"
                type="text"
                @blur="$v.form.documento.$touch()"
                v-model="form.documento"
              />
              <div
                class="form__group-validation"
                v-if="$v.form.documento.$dirty"
              >
                <p v-if="!$v.form.documento.required">
                  Debes especificar un documento.
                </p>
              </div>
            </div>

            <div class="form__group form__group-register">
              <a
                class="waves-effect waves-light m-btn"
                tabindex="0"
                @click="$v.form.$invalid ? $v.form.$touch() : ingresar()"
                @keyup.enter="$v.form.$invalid ? $v.form.$touch() : ingresar()"
                >Ingresar</a
              >
            </div>
          </form>
        </div>
        <div class="form-fields__links">
          <router-link
            class="form-fields__links-link"
            :to="{ name: 'register' }"
            >¿No tienes cuenta? Regístrate.</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  minLength,
  email /*minLength, sameAs*/,
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        email: "",
        documento: "",
        IdTipoDocumento: 1,
        wifi: false,
      },
      formLog: {
        Correo: "",
        Identificacion: "",
        Tipo_Documento: 0 
      },
      imagen:
        "https://clientes.lacentral.com.co/services/facturas/bannerAccount.jpg",
      tiposDocumento: [
        { idTiposDocumento: 1, descripcion: "C.C." },
        { idTiposDocumento: 3, descripcion: "C.E." },
        { idTiposDocumento: 4, descripcion: "Pasaporte." },
      ],
    };
  },
  created() {
    //this.validarUrl();
    this.$store.estadoWifi = false;
    //console.log(this.$store.getters.userId)
    //this.consultarClienteRegistrado()

  },
  mounted(){
    //this.form.email = this.formLog.Correo

  },
  methods: {
    ingresar() {
      const ingreso = {
        email: this.form.email,
        documento: this.form.documento,
        idTipoDocumento: this.form.IdTipoDocumento,
      };
      this.formLog.Correo = ingreso.email;
      this.formLog.Identificacion = ingreso.documento
      this.formLog.Tipo_Documento = ingreso.idTipoDocumento

      this.$store.dispatch("login", ingreso);
    },
     consultarClienteRegistrado(){
       let Token = { 
          userid :this.$store.getters.userId
       }
       //console.log(Token)
        this.$store.dispatch("consultarClienteExistente", Token);
       //console.log(this.$store.state)
    },
    validarUrl() {
      var v = this.paramUrl();
      if (v != null) {
        if (v.wifi) {
          this.$store.dispatch("validarWifi");
        }
      }
    },
    paramUrl() {
      // capturamos la url
      var loc = document.location.href;
      // si existe el interrogante
      if (loc.indexOf("?") > 0) {
        // cogemos la parte de la url que hay despues del interrogante
        var getString = loc.split("?")[1];
        // obtenemos un array con cada clave=valor
        var GET = getString.split("&");
        var get = {};

        // recorremos todo el array de valores
        for (var i = 0, l = GET.length; i < l; i++) {
          var tmp = GET[i].split("=");
          get[tmp[0]] = unescape(decodeURI(tmp[1]));
        }
        return get;
      }
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      documento: {
        required,
        minLength: minLength(6),
      },
      IdTipoDocumento: {
        minValue: minValue(1),
      },
    },
  },
};
</script>

